import type { ComboboxOption } from '@/components/ui/Combobox'

interface NominatimResult {
  place_id: number
  display_name: string
  name: string
  lat: string
  lon: string
}

const NOMINATIM_HEADERS = {
  'Accept-Language': 'fr',
  'User-Agent': 'Oummanet/1.0 (oummanetfr@gmail.com)',
}

export async function searchAddress(
  query: string,
): Promise<Array<ComboboxOption>> {
  const params = new URLSearchParams({
    q: query,
    format: 'json',
    limit: '5',
    addressdetails: '1',
  })
  const res = await fetch(
    `https://nominatim.openstreetmap.org/search?${params}`,
    { headers: NOMINATIM_HEADERS },
  )
  const data: Array<NominatimResult> = await res.json()
  return data.map((r) => ({
    label: r.name || r.display_name.split(',')[0],
    value: r.display_name,
    description: r.display_name,
  }))
}

export interface CityOption extends ComboboxOption {
  lat: number
  lng: number
}

export async function searchCity(query: string): Promise<Array<CityOption>> {
  const params = new URLSearchParams({
    q: query,
    format: 'json',
    limit: '5',
    addressdetails: '0',
    featuretype: 'city',
  })
  const res = await fetch(
    `https://nominatim.openstreetmap.org/search?${params}`,
    { headers: NOMINATIM_HEADERS },
  )
  const data: Array<NominatimResult> = await res.json()
  const out: Array<CityOption> = []
  for (const r of data) {
    const lat = parseFloat(r.lat)
    const lng = parseFloat(r.lon)
    if (Number.isNaN(lat) || Number.isNaN(lng)) continue
    const label = r.name || r.display_name.split(',')[0]
    out.push({
      label,
      value: `${label}|${lat.toFixed(5)},${lng.toFixed(5)}`,
      description: r.display_name,
      lat,
      lng,
    })
  }
  return out
}
